import { useGame } from "@/hooks/useGame"
import clsx from "clsx"

const ScoreLine = ({
  number,
  className,
  light,
}: {
  number: number
  className: string
  light?: boolean
}) => (
  <div
    className={clsx(
      "absolute inset-x-0 flex h-px items-center gap-4 px-2 sm:px-4",
      className
    )}
  >
    <div
      className={clsx(
        "text-sm leading-none sm:text-[15px]",
        light ? "text-white/20" : "text-gray-800/20"
      )}
    >
      {number}
    </div>
    <div
      className={clsx(
        "h-px w-full flex-1",
        light ? "bg-white/20" : "bg-gray-800/20"
      )}
    />
    <div
      className={clsx(
        "text-sm leading-none sm:text-[15px]",
        light ? "text-white/20" : "text-gray-800/20"
      )}
    >
      {number}
    </div>
  </div>
)

const ScoreLines = () => {
  const { analysis, analyze, orientation } = useGame()
  let { advantage, score } = analysis || {}

  let blackHeight = 50
  let whiteHeight = 50

  if (score === "#1") {
    if (advantage === "w") {
      blackHeight = 0
      whiteHeight = 100
    } else {
      blackHeight = 100
      whiteHeight = 0
    }
  } else if (!isNaN(Number(score))) {
    score = Number(score)
    const height = Math.min(Math.abs(score / 4) * 50, 50)
    blackHeight = 50 + height * (score > 0 ? -1 : 1)
    whiteHeight = 50 + height * (score < 0 ? -1 : 1)
  }

  const backgrounds = [
    <div
      key="black"
      className="h-1/2 bg-gray-800 transition-all"
      style={
        analyze
          ? {
              height: `${blackHeight}%`,
            }
          : {}
      }
    >
      {analyze && (
        <>
          <ScoreLine number={4} className="top-0" light />
          <ScoreLine number={3} className="top-[12.5%]" light />
          <ScoreLine number={2} className="top-1/4" light />
          <ScoreLine number={1} className="top-[37.5%]" light />

          <ScoreLine number={1} className="bottom-[37.5%]" light />
          <ScoreLine number={2} className="bottom-1/4" light />
          <ScoreLine number={3} className="bottom-[12.5%]" light />
          <ScoreLine number={4} className="bottom-0" light />
        </>
      )}
    </div>,
    <div
      key="white"
      className="h-1/2 bg-white transition-all"
      style={analyze ? { height: `${whiteHeight}%` } : {}}
    >
      {analyze && (
        <>
          <ScoreLine number={4} className="top-0" />
          <ScoreLine number={3} className="top-[12.5%]" />
          <ScoreLine number={2} className="top-1/4" />
          <ScoreLine number={1} className="top-[37.5%]" />

          <ScoreLine number={1} className="bottom-[37.5%]" />
          <ScoreLine number={2} className="bottom-1/4" />
          <ScoreLine number={3} className="bottom-[12.5%]" />
          <ScoreLine number={4} className="bottom-0" />
        </>
      )}
    </div>,
  ]

  return (
    <>
      <div className="absolute inset-0">
        {orientation === "white" ? backgrounds : backgrounds.reverse()}
      </div>

      <div className="absolute inset-x-0 z-20 h-0.5 bg-red-500" />
    </>
  )
}

export default ScoreLines
